module.exports = "<svg id=51de220b-4778-40f7-aebe-b491ce003211 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Printed</title><path d=M20,4H3V19a1,1,0,0,0,1,1H21V5A1,1,0,0,0,20,4Zm0,1V8.56H4V5ZM4,19V9.56H20V19Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/printed.svg
// module id = 165
// module chunks = 0